export var TileIneligibleReason;
(function (TileIneligibleReason) {
    TileIneligibleReason["NON_CHART_TILE"] = "non_chart_tile";
    TileIneligibleReason["SQL_CHART"] = "sql_chart";
    TileIneligibleReason["ORPHANED_CHART"] = "orphaned_chart";
    TileIneligibleReason["EXPLORE_RESOLUTION_ERROR"] = "explore_resolution_error";
})(TileIneligibleReason || (TileIneligibleReason = {}));
//# sourceMappingURL=audit.js.map